import React from "react";
import CSSModules from "lib/utils/css-modules";

import { PaymentProfileLabel, FormControl } from "lib/index";
import styles from "./CompanyPaymentProfileRelationFormSection.less";

@CSSModules(styles)
export default class CompanyPaymentProfileRelationFormSection extends React.PureComponent {
  render() {
    const { pp, relation, onEditClick, onChange } = this.props;
    const products = this.props.products.records || [];
    const handleChange = (product_variants_ids) =>
      product_variants_ids === null
        ? onChange({ ...relation, product_variants_assignation_type: "product_variants_assignation_all" })
        : onChange({
            ...relation,
            product_variants_assignation_type: "product_variants_assignation_some",
            product_variants_ids,
          });

    const pvOptions = [];
    products.forEach((p) => {
      p.product_variants.forEach((pv) => {
        const option = [pv.id, [p.name, pv.name].filter((x) => !!x).join(" - ")];
        pvOptions.push(option);
      });
    });

    const onEditClickCallback = st.authorize.company.id === 100 ? onEditClick : false;

    return (
      <div styleName="profile">
        <div styleName="profile-row">
          <div styleName="profile-label">
            <PaymentProfileLabel pp={pp} onEditClick={onEditClickCallback} />
          </div>
          <div styleName="profile-select">
            <FormControl.SelectLimitFormGroup
              value={
                relation.product_variants_assignation_type === "product_variants_assignation_some"
                  ? relation.product_variants_ids
                  : null
              }
              onChange={handleChange}
              label={I18n.t("papp.settings.PaymentsSettingsView.enable_for_all_product_variants")}
              options={pvOptions}
              type="MultipleCheckbox"
              inline={false}
              initialSelectedValues={relation.product_variants_ids}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/PaymentsSettingsView/CompanyPaymentProfileRelationFormSection.jsx